export default __webpack_public_path__ + "static/media/06-family_preview.84c10184.jpg";